
<template>
  <el-dialog title="选择图标" width="45%" :visible.sync="dialogFormVisible">

    <div class="ico-list" @click="selectIcon($event)">
      <i class="fa fa-address-book" aria-hidden="true"></i>

      <i class="fa fa-address-book-o" aria-hidden="true"></i>

      <i class="fa fa-address-card" aria-hidden="true"></i>

      <i class="fa fa-address-card-o" aria-hidden="true"></i>

      <i class="fa fa-adjust" aria-hidden="true"></i>

      <i class="fa fa-american-sign-language-interpreting" aria-hidden="true"></i>

      <i class="fa fa-anchor" aria-hidden="true"></i>

      <i class="fa fa-archive" aria-hidden="true"></i>

      <i class="fa fa-area-chart" aria-hidden="true"></i>

      <i class="fa fa-arrows" aria-hidden="true"></i>

      <i class="fa fa-arrows-h" aria-hidden="true"></i>

      <i class="fa fa-arrows-v" aria-hidden="true"></i>

      <i class="fa fa-asl-interpreting" aria-hidden="true"></i>

      <i class="fa fa-assistive-listening-systems" aria-hidden="true"></i>

      <i class="fa fa-asterisk" aria-hidden="true"></i>

      <i class="fa fa-at" aria-hidden="true"></i>

      <i class="fa fa-audio-description" aria-hidden="true"></i>

      <i class="fa fa-automobile" aria-hidden="true"></i>

      <i class="fa fa-balance-scale" aria-hidden="true"></i>

      <i class="fa fa-ban" aria-hidden="true"></i>

      <i class="fa fa-bank" aria-hidden="true"></i>

      <i class="fa fa-bar-chart" aria-hidden="true"></i>

      <i class="fa fa-bar-chart-o" aria-hidden="true"></i>

      <i class="fa fa-barcode" aria-hidden="true"></i>

      <i class="fa fa-bars" aria-hidden="true"></i>

      <i class="fa fa-bath" aria-hidden="true"></i>

      <i class="fa fa-bathtub" aria-hidden="true"></i>

      <i class="fa fa-battery" aria-hidden="true"></i>

      <i class="fa fa-battery-0" aria-hidden="true"></i>

      <i class="fa fa-battery-1" aria-hidden="true"></i>

      <i class="fa fa-battery-2" aria-hidden="true"></i>

      <i class="fa fa-battery-3" aria-hidden="true"></i>

      <i class="fa fa-battery-4" aria-hidden="true"></i>

      <i class="fa fa-battery-empty" aria-hidden="true"></i>

      <i class="fa fa-battery-full" aria-hidden="true"></i>

      <i class="fa fa-battery-half" aria-hidden="true"></i>

      <i class="fa fa-battery-quarter" aria-hidden="true"></i>

      <i class="fa fa-battery-three-quarters" aria-hidden="true"></i>

      <i class="fa fa-bed" aria-hidden="true"></i>

      <i class="fa fa-beer" aria-hidden="true"></i>

      <i class="fa fa-bell" aria-hidden="true"></i>

      <i class="fa fa-bell-o" aria-hidden="true"></i>

      <i class="fa fa-bell-slash" aria-hidden="true"></i>

      <i class="fa fa-bell-slash-o" aria-hidden="true"></i>

      <i class="fa fa-bicycle" aria-hidden="true"></i>

      <i class="fa fa-binoculars" aria-hidden="true"></i>

      <i class="fa fa-birthday-cake" aria-hidden="true"></i>

      <i class="fa fa-blind" aria-hidden="true"></i>

      <i class="fa fa-bluetooth" aria-hidden="true"></i>

      <i class="fa fa-bluetooth-b" aria-hidden="true"></i>

      <i class="fa fa-bolt" aria-hidden="true"></i>

      <i class="fa fa-bomb" aria-hidden="true"></i>

      <i class="fa fa-book" aria-hidden="true"></i>

      <i class="fa fa-bookmark" aria-hidden="true"></i>

      <i class="fa fa-bookmark-o" aria-hidden="true"></i>

      <i class="fa fa-braille" aria-hidden="true"></i>

      <i class="fa fa-briefcase" aria-hidden="true"></i>

      <i class="fa fa-bug" aria-hidden="true"></i>

      <i class="fa fa-building" aria-hidden="true"></i>

      <i class="fa fa-building-o" aria-hidden="true"></i>

      <i class="fa fa-bullhorn" aria-hidden="true"></i>

      <i class="fa fa-bullseye" aria-hidden="true"></i>

      <i class="fa fa-bus" aria-hidden="true"></i>

      <i class="fa fa-cab" aria-hidden="true"></i>

      <i class="fa fa-calculator" aria-hidden="true"></i>

      <i class="fa fa-calendar" aria-hidden="true"></i>

      <i class="fa fa-calendar-check-o" aria-hidden="true"></i>

      <i class="fa fa-calendar-minus-o" aria-hidden="true"></i>

      <i class="fa fa-calendar-o" aria-hidden="true"></i>

      <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>

      <i class="fa fa-calendar-times-o" aria-hidden="true"></i>

      <i class="fa fa-camera" aria-hidden="true"></i>

      <i class="fa fa-camera-retro" aria-hidden="true"></i>

      <i class="fa fa-car" aria-hidden="true"></i>

      <i class="fa fa-caret-square-o-down" aria-hidden="true"></i>

      <i class="fa fa-caret-square-o-left" aria-hidden="true"></i>

      <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>

      <i class="fa fa-caret-square-o-up" aria-hidden="true"></i>

      <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>

      <i class="fa fa-cart-plus" aria-hidden="true"></i>

      <i class="fa fa-cc" aria-hidden="true"></i>

      <i class="fa fa-certificate" aria-hidden="true"></i>

      <i class="fa fa-check" aria-hidden="true"></i>

      <i class="fa fa-check-circle" aria-hidden="true"></i>

      <i class="fa fa-check-circle-o" aria-hidden="true"></i>

      <i class="fa fa-check-square" aria-hidden="true"></i>

      <i class="fa fa-check-square-o" aria-hidden="true"></i>

      <i class="fa fa-child" aria-hidden="true"></i>

      <i class="fa fa-circle" aria-hidden="true"></i>

      <i class="fa fa-circle-o" aria-hidden="true"></i>

      <i class="fa fa-circle-o-notch" aria-hidden="true"></i>

      <i class="fa fa-circle-thin" aria-hidden="true"></i>

      <i class="fa fa-clock-o" aria-hidden="true"></i>

      <i class="fa fa-clone" aria-hidden="true"></i>

      <i class="fa fa-close" aria-hidden="true"></i>

      <i class="fa fa-cloud" aria-hidden="true"></i>

      <i class="fa fa-cloud-download" aria-hidden="true"></i>

      <i class="fa fa-cloud-upload" aria-hidden="true"></i>

      <i class="fa fa-code" aria-hidden="true"></i>

      <i class="fa fa-code-fork" aria-hidden="true"></i>

      <i class="fa fa-coffee" aria-hidden="true"></i>

      <i class="fa fa-cog" aria-hidden="true"></i>

      <i class="fa fa-cogs" aria-hidden="true"></i>

      <i class="fa fa-comment" aria-hidden="true"></i>

      <i class="fa fa-comment-o" aria-hidden="true"></i>

      <i class="fa fa-commenting" aria-hidden="true"></i>

      <i class="fa fa-commenting-o" aria-hidden="true"></i>

      <i class="fa fa-comments" aria-hidden="true"></i>

      <i class="fa fa-comments-o" aria-hidden="true"></i>

      <i class="fa fa-compass" aria-hidden="true"></i>

      <i class="fa fa-copyright" aria-hidden="true"></i>

      <i class="fa fa-creative-commons" aria-hidden="true"></i>

      <i class="fa fa-credit-card" aria-hidden="true"></i>

      <i class="fa fa-credit-card-alt" aria-hidden="true"></i>

      <i class="fa fa-crop" aria-hidden="true"></i>

      <i class="fa fa-crosshairs" aria-hidden="true"></i>

      <i class="fa fa-cube" aria-hidden="true"></i>

      <i class="fa fa-cubes" aria-hidden="true"></i>

      <i class="fa fa-cutlery" aria-hidden="true"></i>

      <i class="fa fa-dashboard" aria-hidden="true"></i>

      <i class="fa fa-database" aria-hidden="true"></i>

      <i class="fa fa-deaf" aria-hidden="true"></i>

      <i class="fa fa-deafness" aria-hidden="true"></i>

      <i class="fa fa-desktop" aria-hidden="true"></i>

      <i class="fa fa-diamond" aria-hidden="true"></i>

      <i class="fa fa-dot-circle-o" aria-hidden="true"></i>

      <i class="fa fa-download" aria-hidden="true"></i>

      <i class="fa fa-drivers-license" aria-hidden="true"></i>

      <i class="fa fa-drivers-license-o" aria-hidden="true"></i>

      <i class="fa fa-edit" aria-hidden="true"></i>

      <i class="fa fa-ellipsis-h" aria-hidden="true"></i>

      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>

      <i class="fa fa-envelope" aria-hidden="true"></i>

      <i class="fa fa-envelope-o" aria-hidden="true"></i>

      <i class="fa fa-envelope-open" aria-hidden="true"></i>

      <i class="fa fa-envelope-open-o" aria-hidden="true"></i>

      <i class="fa fa-envelope-square" aria-hidden="true"></i>

      <i class="fa fa-eraser" aria-hidden="true"></i>

      <i class="fa fa-exchange" aria-hidden="true"></i>

      <i class="fa fa-exclamation" aria-hidden="true"></i>

      <i class="fa fa-exclamation-circle" aria-hidden="true"></i>

      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>

      <i class="fa fa-external-link" aria-hidden="true"></i>

      <i class="fa fa-external-link-square" aria-hidden="true"></i>

      <i class="fa fa-eye" aria-hidden="true"></i>

      <i class="fa fa-eye-slash" aria-hidden="true"></i>

      <i class="fa fa-eyedropper" aria-hidden="true"></i>

      <i class="fa fa-fax" aria-hidden="true"></i>

      <i class="fa fa-feed" aria-hidden="true"></i>

      <i class="fa fa-female" aria-hidden="true"></i>

      <i class="fa fa-fighter-jet" aria-hidden="true"></i>

      <i class="fa fa-file-archive-o" aria-hidden="true"></i>

      <i class="fa fa-file-audio-o" aria-hidden="true"></i>

      <i class="fa fa-file-code-o" aria-hidden="true"></i>

      <i class="fa fa-file-excel-o" aria-hidden="true"></i>

      <i class="fa fa-file-image-o" aria-hidden="true"></i>

      <i class="fa fa-file-movie-o" aria-hidden="true"></i>

      <i class="fa fa-file-pdf-o" aria-hidden="true"></i>

      <i class="fa fa-file-photo-o" aria-hidden="true"></i>

      <i class="fa fa-file-picture-o" aria-hidden="true"></i>

      <i class="fa fa-file-powerpoint-o" aria-hidden="true"></i>

      <i class="fa fa-file-sound-o" aria-hidden="true"></i>

      <i class="fa fa-file-video-o" aria-hidden="true"></i>

      <i class="fa fa-file-word-o" aria-hidden="true"></i>

      <i class="fa fa-file-zip-o" aria-hidden="true"></i>

      <i class="fa fa-film" aria-hidden="true"></i>

      <i class="fa fa-filter" aria-hidden="true"></i>

      <i class="fa fa-fire" aria-hidden="true"></i>

      <i class="fa fa-fire-extinguisher" aria-hidden="true"></i>

      <i class="fa fa-flag" aria-hidden="true"></i>

      <i class="fa fa-flag-checkered" aria-hidden="true"></i>

      <i class="fa fa-flag-o" aria-hidden="true"></i>

      <i class="fa fa-flash" aria-hidden="true"></i>

      <i class="fa fa-flask" aria-hidden="true"></i>

      <i class="fa fa-folder" aria-hidden="true"></i>

      <i class="fa fa-folder-o" aria-hidden="true"></i>

      <i class="fa fa-folder-open" aria-hidden="true"></i>

      <i class="fa fa-folder-open-o" aria-hidden="true"></i>

      <i class="fa fa-frown-o" aria-hidden="true"></i>

      <i class="fa fa-futbol-o" aria-hidden="true"></i>

      <i class="fa fa-gamepad" aria-hidden="true"></i>

      <i class="fa fa-gavel" aria-hidden="true"></i>

      <i class="fa fa-gear" aria-hidden="true"></i>

      <i class="fa fa-gears" aria-hidden="true"></i>

      <i class="fa fa-gift" aria-hidden="true"></i>

      <i class="fa fa-glass" aria-hidden="true"></i>

      <i class="fa fa-globe" aria-hidden="true"></i>

      <i class="fa fa-graduation-cap" aria-hidden="true"></i>

      <i class="fa fa-group" aria-hidden="true"></i>

      <i class="fa fa-hand-grab-o" aria-hidden="true"></i>

      <i class="fa fa-hand-lizard-o" aria-hidden="true"></i>

      <i class="fa fa-hand-paper-o" aria-hidden="true"></i>

      <i class="fa fa-hand-peace-o" aria-hidden="true"></i>

      <i class="fa fa-hand-pointer-o" aria-hidden="true"></i>

      <i class="fa fa-hand-rock-o" aria-hidden="true"></i>

      <i class="fa fa-hand-scissors-o" aria-hidden="true"></i>

      <i class="fa fa-hand-spock-o" aria-hidden="true"></i>

      <i class="fa fa-hand-stop-o" aria-hidden="true"></i>

      <i class="fa fa-handshake-o" aria-hidden="true"></i>

      <i class="fa fa-hard-of-hearing" aria-hidden="true"></i>

      <i class="fa fa-hashtag" aria-hidden="true"></i>

      <i class="fa fa-hdd-o" aria-hidden="true"></i>

      <i class="fa fa-headphones" aria-hidden="true"></i>

      <i class="fa fa-heart" aria-hidden="true"></i>

      <i class="fa fa-heart-o" aria-hidden="true"></i>

      <i class="fa fa-heartbeat" aria-hidden="true"></i>

      <i class="fa fa-history" aria-hidden="true"></i>

      <i class="fa fa-home" aria-hidden="true"></i>

      <i class="fa fa-hotel" aria-hidden="true"></i>

      <i class="fa fa-hourglass" aria-hidden="true"></i>

      <i class="fa fa-hourglass-1" aria-hidden="true"></i>

      <i class="fa fa-hourglass-2" aria-hidden="true"></i>

      <i class="fa fa-hourglass-3" aria-hidden="true"></i>

      <i class="fa fa-hourglass-end" aria-hidden="true"></i>

      <i class="fa fa-hourglass-half" aria-hidden="true"></i>

      <i class="fa fa-hourglass-o" aria-hidden="true"></i>

      <i class="fa fa-hourglass-start" aria-hidden="true"></i>

      <i class="fa fa-i-cursor" aria-hidden="true"></i>

      <i class="fa fa-id-badge" aria-hidden="true"></i>

      <i class="fa fa-id-card" aria-hidden="true"></i>

      <i class="fa fa-id-card-o" aria-hidden="true"></i>

      <i class="fa fa-image" aria-hidden="true"></i>

      <i class="fa fa-inbox" aria-hidden="true"></i>

      <i class="fa fa-industry" aria-hidden="true"></i>

      <i class="fa fa-info" aria-hidden="true"></i>

      <i class="fa fa-info-circle" aria-hidden="true"></i>

      <i class="fa fa-institution" aria-hidden="true"></i>

      <i class="fa fa-key" aria-hidden="true"></i>

      <i class="fa fa-keyboard-o" aria-hidden="true"></i>

      <i class="fa fa-language" aria-hidden="true"></i>

      <i class="fa fa-laptop" aria-hidden="true"></i>

      <i class="fa fa-leaf" aria-hidden="true"></i>

      <i class="fa fa-legal" aria-hidden="true"></i>

      <i class="fa fa-lemon-o" aria-hidden="true"></i>

      <i class="fa fa-level-down" aria-hidden="true"></i>

      <i class="fa fa-level-up" aria-hidden="true"></i>

      <i class="fa fa-life-bouy" aria-hidden="true"></i>

      <i class="fa fa-life-buoy" aria-hidden="true"></i>

      <i class="fa fa-life-ring" aria-hidden="true"></i>

      <i class="fa fa-life-saver" aria-hidden="true"></i>

      <i class="fa fa-lightbulb-o" aria-hidden="true"></i>

      <i class="fa fa-line-chart" aria-hidden="true"></i>

      <i class="fa fa-location-arrow" aria-hidden="true"></i>

      <i class="fa fa-lock" aria-hidden="true"></i>

      <i class="fa fa-low-vision" aria-hidden="true"></i>

      <i class="fa fa-magic" aria-hidden="true"></i>

      <i class="fa fa-magnet" aria-hidden="true"></i>

      <i class="fa fa-mail-forward" aria-hidden="true"></i>

      <i class="fa fa-mail-reply" aria-hidden="true"></i>

      <i class="fa fa-mail-reply-all" aria-hidden="true"></i>

      <i class="fa fa-male" aria-hidden="true"></i>

      <i class="fa fa-map" aria-hidden="true"></i>

      <i class="fa fa-map-marker" aria-hidden="true"></i>

      <i class="fa fa-map-o" aria-hidden="true"></i>

      <i class="fa fa-map-pin" aria-hidden="true"></i>

      <i class="fa fa-map-signs" aria-hidden="true"></i>

      <i class="fa fa-meh-o" aria-hidden="true"></i>

      <i class="fa fa-microchip" aria-hidden="true"></i>

      <i class="fa fa-microphone" aria-hidden="true"></i>

      <i class="fa fa-microphone-slash" aria-hidden="true"></i>

      <i class="fa fa-minus" aria-hidden="true"></i>

      <i class="fa fa-minus-circle" aria-hidden="true"></i>

      <i class="fa fa-minus-square" aria-hidden="true"></i>

      <i class="fa fa-minus-square-o" aria-hidden="true"></i>

      <i class="fa fa-mobile" aria-hidden="true"></i>

      <i class="fa fa-mobile-phone" aria-hidden="true"></i>

      <i class="fa fa-money" aria-hidden="true"></i>

      <i class="fa fa-moon-o" aria-hidden="true"></i>

      <i class="fa fa-mortar-board" aria-hidden="true"></i>

      <i class="fa fa-motorcycle" aria-hidden="true"></i>

      <i class="fa fa-mouse-pointer" aria-hidden="true"></i>

      <i class="fa fa-music" aria-hidden="true"></i>

      <i class="fa fa-navicon" aria-hidden="true"></i>

      <i class="fa fa-newspaper-o" aria-hidden="true"></i>

      <i class="fa fa-object-group" aria-hidden="true"></i>

      <i class="fa fa-object-ungroup" aria-hidden="true"></i>

      <i class="fa fa-paint-brush" aria-hidden="true"></i>

      <i class="fa fa-paper-plane" aria-hidden="true"></i>

      <i class="fa fa-paper-plane-o" aria-hidden="true"></i>

      <i class="fa fa-paw" aria-hidden="true"></i>

      <i class="fa fa-pencil" aria-hidden="true"></i>

      <i class="fa fa-pencil-square" aria-hidden="true"></i>

      <i class="fa fa-pencil-square-o" aria-hidden="true"></i>

      <i class="fa fa-percent" aria-hidden="true"></i>

      <i class="fa fa-phone" aria-hidden="true"></i>

      <i class="fa fa-phone-square" aria-hidden="true"></i>

      <i class="fa fa-photo" aria-hidden="true"></i>

      <i class="fa fa-picture-o" aria-hidden="true"></i>

      <i class="fa fa-pie-chart" aria-hidden="true"></i>

      <i class="fa fa-plane" aria-hidden="true"></i>

      <i class="fa fa-plug" aria-hidden="true"></i>

      <i class="fa fa-plus" aria-hidden="true"></i>

      <i class="fa fa-plus-circle" aria-hidden="true"></i>

      <i class="fa fa-plus-square" aria-hidden="true"></i>

      <i class="fa fa-plus-square-o" aria-hidden="true"></i>

      <i class="fa fa-podcast" aria-hidden="true"></i>

      <i class="fa fa-power-off" aria-hidden="true"></i>

      <i class="fa fa-print" aria-hidden="true"></i>

      <i class="fa fa-puzzle-piece" aria-hidden="true"></i>

      <i class="fa fa-qrcode" aria-hidden="true"></i>

      <i class="fa fa-question" aria-hidden="true"></i>

      <i class="fa fa-question-circle" aria-hidden="true"></i>

      <i class="fa fa-question-circle-o" aria-hidden="true"></i>

      <i class="fa fa-quote-left" aria-hidden="true"></i>

      <i class="fa fa-quote-right" aria-hidden="true"></i>

      <i class="fa fa-random" aria-hidden="true"></i>

      <i class="fa fa-recycle" aria-hidden="true"></i>

      <i class="fa fa-refresh" aria-hidden="true"></i>

      <i class="fa fa-registered" aria-hidden="true"></i>

      <i class="fa fa-remove" aria-hidden="true"></i>

      <i class="fa fa-reorder" aria-hidden="true"></i>

      <i class="fa fa-reply" aria-hidden="true"></i>

      <i class="fa fa-reply-all" aria-hidden="true"></i>

      <i class="fa fa-retweet" aria-hidden="true"></i>

      <i class="fa fa-road" aria-hidden="true"></i>

      <i class="fa fa-rocket" aria-hidden="true"></i>

      <i class="fa fa-rss" aria-hidden="true"></i>

      <i class="fa fa-rss-square" aria-hidden="true"></i>

      <i class="fa fa-s15" aria-hidden="true"></i>

      <i class="fa fa-search" aria-hidden="true"></i>

      <i class="fa fa-search-minus" aria-hidden="true"></i>

      <i class="fa fa-search-plus" aria-hidden="true"></i>

      <i class="fa fa-send" aria-hidden="true"></i>

      <i class="fa fa-send-o" aria-hidden="true"></i>

      <i class="fa fa-server" aria-hidden="true"></i>

      <i class="fa fa-share" aria-hidden="true"></i>

      <i class="fa fa-share-alt" aria-hidden="true"></i>

      <i class="fa fa-share-alt-square" aria-hidden="true"></i>

      <i class="fa fa-share-square" aria-hidden="true"></i>

      <i class="fa fa-share-square-o" aria-hidden="true"></i>

      <i class="fa fa-shield" aria-hidden="true"></i>

      <i class="fa fa-ship" aria-hidden="true"></i>

      <i class="fa fa-shopping-bag" aria-hidden="true"></i>

      <i class="fa fa-shopping-basket" aria-hidden="true"></i>

      <i class="fa fa-shopping-cart" aria-hidden="true"></i>

      <i class="fa fa-shower" aria-hidden="true"></i>

      <i class="fa fa-sign-in" aria-hidden="true"></i>

      <i class="fa fa-sign-language" aria-hidden="true"></i>

      <i class="fa fa-sign-out" aria-hidden="true"></i>

      <i class="fa fa-signal" aria-hidden="true"></i>

      <i class="fa fa-signing" aria-hidden="true"></i>

      <i class="fa fa-sitemap" aria-hidden="true"></i>

      <i class="fa fa-sliders" aria-hidden="true"></i>

      <i class="fa fa-smile-o" aria-hidden="true"></i>

      <i class="fa fa-snowflake-o" aria-hidden="true"></i>

      <i class="fa fa-soccer-ball-o" aria-hidden="true"></i>

      <i class="fa fa-sort" aria-hidden="true"></i>

      <i class="fa fa-sort-alpha-asc" aria-hidden="true"></i>

      <i class="fa fa-sort-alpha-desc" aria-hidden="true"></i>

      <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>

      <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>

      <i class="fa fa-sort-asc" aria-hidden="true"></i>

      <i class="fa fa-sort-desc" aria-hidden="true"></i>

      <i class="fa fa-sort-down" aria-hidden="true"></i>

      <i class="fa fa-sort-numeric-asc" aria-hidden="true"></i>

      <i class="fa fa-sort-numeric-desc" aria-hidden="true"></i>

      <i class="fa fa-sort-up" aria-hidden="true"></i>

      <i class="fa fa-space-shuttle" aria-hidden="true"></i>

      <i class="fa fa-spinner" aria-hidden="true"></i>

      <i class="fa fa-spoon" aria-hidden="true"></i>

      <i class="fa fa-square" aria-hidden="true"></i>

      <i class="fa fa-square-o" aria-hidden="true"></i>

      <i class="fa fa-star" aria-hidden="true"></i>

      <i class="fa fa-star-half" aria-hidden="true"></i>

      <i class="fa fa-star-half-empty" aria-hidden="true"></i>

      <i class="fa fa-star-half-full" aria-hidden="true"></i>

      <i class="fa fa-star-half-o" aria-hidden="true"></i>

      <i class="fa fa-star-o" aria-hidden="true"></i>

      <i class="fa fa-sticky-note" aria-hidden="true"></i>

      <i class="fa fa-sticky-note-o" aria-hidden="true"></i>

      <i class="fa fa-street-view" aria-hidden="true"></i>

      <i class="fa fa-suitcase" aria-hidden="true"></i>

      <i class="fa fa-sun-o" aria-hidden="true"></i>

      <i class="fa fa-support" aria-hidden="true"></i>

      <i class="fa fa-tablet" aria-hidden="true"></i>

      <i class="fa fa-tachometer" aria-hidden="true"></i>

      <i class="fa fa-tag" aria-hidden="true"></i>

      <i class="fa fa-tags" aria-hidden="true"></i>

      <i class="fa fa-tasks" aria-hidden="true"></i>

      <i class="fa fa-taxi" aria-hidden="true"></i>

      <i class="fa fa-television" aria-hidden="true"></i>

      <i class="fa fa-terminal" aria-hidden="true"></i>

      <i class="fa fa-thermometer" aria-hidden="true"></i>

      <i class="fa fa-thermometer-0" aria-hidden="true"></i>

      <i class="fa fa-thermometer-1" aria-hidden="true"></i>

      <i class="fa fa-thermometer-2" aria-hidden="true"></i>

      <i class="fa fa-thermometer-3" aria-hidden="true"></i>

      <i class="fa fa-thermometer-4" aria-hidden="true"></i>

      <i class="fa fa-thermometer-empty" aria-hidden="true"></i>

      <i class="fa fa-thermometer-full" aria-hidden="true"></i>

      <i class="fa fa-thermometer-half" aria-hidden="true"></i>

      <i class="fa fa-thermometer-quarter" aria-hidden="true"></i>

      <i class="fa fa-thermometer-three-quarters" aria-hidden="true"></i>

      <i class="fa fa-thumb-tack" aria-hidden="true"></i>

      <i class="fa fa-thumbs-down" aria-hidden="true"></i>

      <i class="fa fa-thumbs-o-down" aria-hidden="true"></i>

      <i class="fa fa-thumbs-o-up" aria-hidden="true"></i>

      <i class="fa fa-thumbs-up" aria-hidden="true"></i>

      <i class="fa fa-ticket" aria-hidden="true"></i>

      <i class="fa fa-times" aria-hidden="true"></i>

      <i class="fa fa-times-circle" aria-hidden="true"></i>

      <i class="fa fa-times-circle-o" aria-hidden="true"></i>

      <i class="fa fa-times-rectangle" aria-hidden="true"></i>

      <i class="fa fa-times-rectangle-o" aria-hidden="true"></i>

      <i class="fa fa-tint" aria-hidden="true"></i>

      <i class="fa fa-toggle-down" aria-hidden="true"></i>

      <i class="fa fa-toggle-left" aria-hidden="true"></i>

      <i class="fa fa-toggle-off" aria-hidden="true"></i>

      <i class="fa fa-toggle-on" aria-hidden="true"></i>

      <i class="fa fa-toggle-right" aria-hidden="true"></i>

      <i class="fa fa-toggle-up" aria-hidden="true"></i>

      <i class="fa fa-trademark" aria-hidden="true"></i>

      <i class="fa fa-trash" aria-hidden="true"></i>

      <i class="fa fa-trash-o" aria-hidden="true"></i>

      <i class="fa fa-tree" aria-hidden="true"></i>

      <i class="fa fa-trophy" aria-hidden="true"></i>

      <i class="fa fa-truck" aria-hidden="true"></i>

      <i class="fa fa-tty" aria-hidden="true"></i>

      <i class="fa fa-tv" aria-hidden="true"></i>

      <i class="fa fa-umbrella" aria-hidden="true"></i>

      <i class="fa fa-universal-access" aria-hidden="true"></i>

      <i class="fa fa-university" aria-hidden="true"></i>

      <i class="fa fa-unlock" aria-hidden="true"></i>

      <i class="fa fa-unlock-alt" aria-hidden="true"></i>

      <i class="fa fa-unsorted" aria-hidden="true"></i>

      <i class="fa fa-upload" aria-hidden="true"></i>

      <i class="fa fa-user" aria-hidden="true"></i>

      <i class="fa fa-user-circle" aria-hidden="true"></i>

      <i class="fa fa-user-circle-o" aria-hidden="true"></i>

      <i class="fa fa-user-o" aria-hidden="true"></i>

      <i class="fa fa-user-plus" aria-hidden="true"></i>

      <i class="fa fa-user-secret" aria-hidden="true"></i>

      <i class="fa fa-user-times" aria-hidden="true"></i>

      <i class="fa fa-users" aria-hidden="true"></i>

      <i class="fa fa-vcard" aria-hidden="true"></i>

      <i class="fa fa-vcard-o" aria-hidden="true"></i>

      <i class="fa fa-video-camera" aria-hidden="true"></i>

      <i class="fa fa-volume-control-phone" aria-hidden="true"></i>

      <i class="fa fa-volume-down" aria-hidden="true"></i>

      <i class="fa fa-volume-off" aria-hidden="true"></i>

      <i class="fa fa-volume-up" aria-hidden="true"></i>

      <i class="fa fa-warning" aria-hidden="true"></i>

      <i class="fa fa-wheelchair" aria-hidden="true"></i>

      <i class="fa fa-wheelchair-alt" aria-hidden="true"></i>

      <i class="fa fa-wifi" aria-hidden="true"></i>

      <i class="fa fa-window-close" aria-hidden="true"></i>

      <i class="fa fa-window-close-o" aria-hidden="true"></i>

      <i class="fa fa-window-maximize" aria-hidden="true"></i>

      <i class="fa fa-window-minimize" aria-hidden="true"></i>

      <i class="fa fa-window-restore" aria-hidden="true"></i>

      <i class="fa fa-wrench" aria-hidden="true"></i>

      <!--以下是饿了么的icon-->
      <i class="fa el-icon-platform-eleme" aria-hidden="true"></i>
      <i class="fa el-icon-eleme" aria-hidden="true"></i>
      <i class="fa el-icon-delete-solid" aria-hidden="true"></i>
      <i class="fa el-icon-delete" aria-hidden="true"></i>
      <i class="fa el-icon-s-tools" aria-hidden="true"></i>
      <i class="fa el-icon-setting" aria-hidden="true"></i>
      <i class="fa el-icon-user-solid" aria-hidden="true"></i>
      <i class="fa el-icon-user" aria-hidden="true"></i>
      <i class="fa el-icon-phone" aria-hidden="true"></i>
      <i class="fa el-icon-phone-outline" aria-hidden="true"></i>
      <i class="fa el-icon-more" aria-hidden="true"></i>
      <i class="fa el-icon-more-outline" aria-hidden="true"></i>
      <i class="fa el-icon-star-on" aria-hidden="true"></i>
      <i class="fa el-icon-star-off" aria-hidden="true"></i>
      <i class="fa el-icon-s-goods" aria-hidden="true"></i>
      <i class="fa el-icon-goods" aria-hidden="true"></i>
      <i class="fa el-icon-warning" aria-hidden="true"></i>
      <i class="fa el-icon-warning-outline" aria-hidden="true"></i>
      <i class="fa el-icon-question" aria-hidden="true"></i>
      <i class="fa el-icon-info" aria-hidden="true"></i>
      <i class="fa el-icon-remove" aria-hidden="true"></i>
      <i class="fa el-icon-circle-plus" aria-hidden="true"></i>
      <i class="fa el-icon-success" aria-hidden="true"></i>
      <i class="fa el-icon-error" aria-hidden="true"></i>
      <i class="fa el-icon-zoom-in" aria-hidden="true"></i>
      <i class="fa el-icon-zoom-out" aria-hidden="true"></i>
      <i class="fa el-icon-remove-outline" aria-hidden="true"></i>
      <i class="fa el-icon-circle-plus-outline" aria-hidden="true"></i>
      <i class="fa el-icon-circle-check" aria-hidden="true"></i>
      <i class="fa el-icon-circle-close" aria-hidden="true"></i>
      <i class="fa el-icon-s-help" aria-hidden="true"></i>
      <i class="fa el-icon-help" aria-hidden="true"></i>
      <i class="fa el-icon-minus" aria-hidden="true"></i>
      <i class="fa el-icon-plus" aria-hidden="true"></i>
      <i class="fa el-icon-check" aria-hidden="true"></i>
      <i class="fa el-icon-close" aria-hidden="true"></i>
      <i class="fa el-icon-picture" aria-hidden="true"></i>
      <i class="fa el-icon-picture-outline" aria-hidden="true"></i>
      <i class="fa el-icon-picture-outline-round" aria-hidden="true"></i>
      <i class="fa el-icon-upload" aria-hidden="true"></i>
      <i class="fa el-icon-upload2" aria-hidden="true"></i>
      <i class="fa el-icon-download" aria-hidden="true"></i>
      <i class="fa el-icon-camera-solid" aria-hidden="true"></i>
      <i class="fa el-icon-camera" aria-hidden="true"></i>
      <i class="fa el-icon-video-camera-solid" aria-hidden="true"></i>
      <i class="fa el-icon-video-camera" aria-hidden="true"></i>
      <i class="fa el-icon-message-solid" aria-hidden="true"></i>
      <i class="fa el-icon-bell" aria-hidden="true"></i>
      <i class="fa el-icon-s-cooperation" aria-hidden="true"></i>
      <i class="fa el-icon-s-order" aria-hidden="true"></i>
      <i class="fa el-icon-s-platform" aria-hidden="true"></i>
      <i class="fa el-icon-s-fold" aria-hidden="true"></i>
      <i class="fa el-icon-s-unfold" aria-hidden="true"></i>
      <i class="fa el-icon-s-operation" aria-hidden="true"></i>
      <i class="fa el-icon-s-promotion" aria-hidden="true"></i>
      <i class="fa el-icon-s-home" aria-hidden="true"></i>
      <i class="fa el-icon-s-release" aria-hidden="true"></i>
      <i class="fa el-icon-s-ticket" aria-hidden="true"></i>
      <i class="fa el-icon-s-management" aria-hidden="true"></i>
      <i class="fa el-icon-s-open" aria-hidden="true"></i>
      <i class="fa el-icon-s-shop" aria-hidden="true"></i>
      <i class="fa el-icon-s-marketing" aria-hidden="true"></i>
      <i class="fa el-icon-s-flag" aria-hidden="true"></i>
      <i class="fa el-icon-s-comment" aria-hidden="true"></i>
      <i class="fa el-icon-s-finance" aria-hidden="true"></i>
      <i class="fa el-icon-s-claim" aria-hidden="true"></i>
      <i class="fa el-icon-s-custom" aria-hidden="true"></i>
      <i class="fa el-icon-s-opportunity" aria-hidden="true"></i>
      <i class="fa el-icon-s-data" aria-hidden="true"></i>
      <i class="fa el-icon-s-check" aria-hidden="true"></i>
      <i class="fa el-icon-s-grid" aria-hidden="true"></i>
      <i class="fa el-icon-menu" aria-hidden="true"></i>
      <i class="fa el-icon-share" aria-hidden="true"></i>
      <i class="fa el-icon-d-caret" aria-hidden="true"></i>
      <i class="fa el-icon-caret-left" aria-hidden="true"></i>
      <i class="fa el-icon-caret-right" aria-hidden="true"></i>
      <i class="fa el-icon-caret-bottom" aria-hidden="true"></i>
      <i class="fa el-icon-caret-top" aria-hidden="true"></i>
      <i class="fa el-icon-bottom-left" aria-hidden="true"></i>
      <i class="fa el-icon-bottom-right" aria-hidden="true"></i>
      <i class="fa el-icon-back" aria-hidden="true"></i>
      <i class="fa el-icon-right" aria-hidden="true"></i>
      <i class="fa el-icon-bottom" aria-hidden="true"></i>
      <i class="fa el-icon-top" aria-hidden="true"></i>
      <i class="fa el-icon-top-left" aria-hidden="true"></i>
      <i class="fa el-icon-top-right" aria-hidden="true"></i>
      <i class="fa el-icon-arrow-left" aria-hidden="true"></i>
      <i class="fa el-icon-arrow-right" aria-hidden="true"></i>
      <i class="fa el-icon-arrow-down" aria-hidden="true"></i>
      <i class="fa el-icon-arrow-up" aria-hidden="true"></i>
      <i class="fa el-icon-d-arrow-left" aria-hidden="true"></i>
      <i class="fa el-icon-d-arrow-right" aria-hidden="true"></i>
      <i class="fa el-icon-video-pause" aria-hidden="true"></i>
      <i class="fa el-icon-video-play" aria-hidden="true"></i>
      <i class="fa el-icon-refresh" aria-hidden="true"></i>
      <i class="fa el-icon-refresh-right" aria-hidden="true"></i>
      <i class="fa el-icon-refresh-left" aria-hidden="true"></i>
      <i class="fa el-icon-finished" aria-hidden="true"></i>
      <i class="fa el-icon-sort" aria-hidden="true"></i>
      <i class="fa el-icon-sort-up" aria-hidden="true"></i>
      <i class="fa el-icon-sort-down" aria-hidden="true"></i>
      <i class="fa el-icon-rank" aria-hidden="true"></i>
      <i class="fa el-icon-loading" aria-hidden="true"></i>
      <i class="fa el-icon-view" aria-hidden="true"></i>
      <i class="fa el-icon-c-scale-to-original" aria-hidden="true"></i>
      <i class="fa el-icon-date" aria-hidden="true"></i>
      <i class="fa el-icon-edit" aria-hidden="true"></i>
      <i class="fa el-icon-edit-outline" aria-hidden="true"></i>
      <i class="fa el-icon-folder" aria-hidden="true"></i>
      <i class="fa el-icon-folder-opened" aria-hidden="true"></i>
      <i class="fa el-icon-folder-add" aria-hidden="true"></i>
      <i class="fa el-icon-folder-remove" aria-hidden="true"></i>
      <i class="fa el-icon-folder-delete" aria-hidden="true"></i>
      <i class="fa el-icon-folder-checked" aria-hidden="true"></i>
      <i class="fa el-icon-tickets" aria-hidden="true"></i>
      <i class="fa el-icon-document-remove" aria-hidden="true"></i>
      <i class="fa el-icon-document-delete" aria-hidden="true"></i>
      <i class="fa el-icon-document-copy" aria-hidden="true"></i>
      <i class="fa el-icon-document-checked" aria-hidden="true"></i>
      <i class="fa el-icon-document" aria-hidden="true"></i>
      <i class="fa el-icon-document-add" aria-hidden="true"></i>
      <i class="fa el-icon-printer" aria-hidden="true"></i>
      <i class="fa el-icon-paperclip" aria-hidden="true"></i>
      <i class="fa el-icon-takeaway-box" aria-hidden="true"></i>
      <i class="fa el-icon-search" aria-hidden="true"></i>
      <i class="fa el-icon-monitor" aria-hidden="true"></i>
      <i class="fa el-icon-attract" aria-hidden="true"></i>
      <i class="fa el-icon-mobile" aria-hidden="true"></i>
      <i class="fa el-icon-scissors" aria-hidden="true"></i>
      <i class="fa el-icon-umbrella" aria-hidden="true"></i>
      <i class="fa el-icon-headset" aria-hidden="true"></i>
      <i class="fa el-icon-brush" aria-hidden="true"></i>
      <i class="fa el-icon-mouse" aria-hidden="true"></i>
      <i class="fa el-icon-coordinate" aria-hidden="true"></i>
      <i class="fa el-icon-magic-stick" aria-hidden="true"></i>
      <i class="fa el-icon-reading" aria-hidden="true"></i>
      <i class="fa el-icon-data-line" aria-hidden="true"></i>
      <i class="fa el-icon-data-board" aria-hidden="true"></i>
      <i class="fa el-icon-pie-chart" aria-hidden="true"></i>
      <i class="fa el-icon-data-analysis" aria-hidden="true"></i>
      <i class="fa el-icon-collection-tag" aria-hidden="true"></i>
      <i class="fa el-icon-film" aria-hidden="true"></i>
      <i class="fa el-icon-suitcase" aria-hidden="true"></i>
      <i class="fa el-icon-suitcase-1" aria-hidden="true"></i>
      <i class="fa el-icon-receiving" aria-hidden="true"></i>
      <i class="fa el-icon-collection" aria-hidden="true"></i>
      <i class="fa el-icon-files" aria-hidden="true"></i>
      <i class="fa el-icon-notebook-1" aria-hidden="true"></i>
      <i class="fa el-icon-notebook-2" aria-hidden="true"></i>
      <i class="fa el-icon-toilet-paper" aria-hidden="true"></i>
      <i class="fa el-icon-office-building" aria-hidden="true"></i>
      <i class="fa el-icon-school" aria-hidden="true"></i>
      <i class="fa el-icon-table-lamp" aria-hidden="true"></i>
      <i class="fa el-icon-house" aria-hidden="true"></i>
      <i class="fa el-icon-no-smoking" aria-hidden="true"></i>
      <i class="fa el-icon-smoking" aria-hidden="true"></i>
      <i class="fa el-icon-shopping-cart-full" aria-hidden="true"></i>
      <i class="fa el-icon-shopping-cart-1" aria-hidden="true"></i>
      <i class="fa el-icon-shopping-cart-2" aria-hidden="true"></i>
      <i class="fa el-icon-shopping-bag-1" aria-hidden="true"></i>
      <i class="fa el-icon-shopping-bag-2" aria-hidden="true"></i>
      <i class="fa el-icon-sold-out" aria-hidden="true"></i>
      <i class="fa el-icon-sell" aria-hidden="true"></i>
      <i class="fa el-icon-present" aria-hidden="true"></i>
      <i class="fa el-icon-box" aria-hidden="true"></i>
      <i class="fa el-icon-bank-card" aria-hidden="true"></i>
      <i class="fa el-icon-money" aria-hidden="true"></i>
      <i class="fa el-icon-coin" aria-hidden="true"></i>
      <i class="fa el-icon-wallet" aria-hidden="true"></i>
      <i class="fa el-icon-discount" aria-hidden="true"></i>
      <i class="fa el-icon-price-tag" aria-hidden="true"></i>
      <i class="fa el-icon-news" aria-hidden="true"></i>
      <i class="fa el-icon-guide" aria-hidden="true"></i>
      <i class="fa el-icon-male" aria-hidden="true"></i>
      <i class="fa el-icon-female" aria-hidden="true"></i>
      <i class="fa el-icon-thumb" aria-hidden="true"></i>
      <i class="fa el-icon-cpu" aria-hidden="true"></i>
      <i class="fa el-icon-link" aria-hidden="true"></i>
      <i class="fa el-icon-connection" aria-hidden="true"></i>
      <i class="fa el-icon-open" aria-hidden="true"></i>
      <i class="fa el-icon-turn-off" aria-hidden="true"></i>
      <i class="fa el-icon-set-up" aria-hidden="true"></i>
      <i class="fa el-icon-chat-round" aria-hidden="true"></i>
      <i class="fa el-icon-chat-line-round" aria-hidden="true"></i>
      <i class="fa el-icon-chat-square" aria-hidden="true"></i>
      <i class="fa el-icon-chat-dot-round" aria-hidden="true"></i>
      <i class="fa el-icon-chat-dot-square" aria-hidden="true"></i>
      <i class="fa el-icon-chat-line-square" aria-hidden="true"></i>
      <i class="fa el-icon-message" aria-hidden="true"></i>
      <i class="fa el-icon-postcard" aria-hidden="true"></i>
      <i class="fa el-icon-position" aria-hidden="true"></i>
      <i class="fa el-icon-turn-off-microphone" aria-hidden="true"></i>
      <i class="fa el-icon-microphone" aria-hidden="true"></i>
      <i class="fa el-icon-close-notification" aria-hidden="true"></i>
      <i class="fa el-icon-bangzhu" aria-hidden="true"></i>
      <i class="fa el-icon-time" aria-hidden="true"></i>
      <i class="fa el-icon-odometer" aria-hidden="true"></i>
      <i class="fa el-icon-crop" aria-hidden="true"></i>
      <i class="fa el-icon-aim" aria-hidden="true"></i>
      <i class="fa el-icon-switch-button" aria-hidden="true"></i>
      <i class="fa el-icon-full-screen" aria-hidden="true"></i>
      <i class="fa el-icon-copy-document" aria-hidden="true"></i>
      <i class="fa el-icon-mic" aria-hidden="true"></i>
      <i class="fa el-icon-stopwatch" aria-hidden="true"></i>
      <i class="fa el-icon-medal-1" aria-hidden="true"></i>
      <i class="fa el-icon-medal" aria-hidden="true"></i>
      <i class="fa el-icon-trophy" aria-hidden="true"></i>
      <i class="fa el-icon-trophy-1" aria-hidden="true"></i>
      <i class="fa el-icon-first-aid-kit" aria-hidden="true"></i>
      <i class="fa el-icon-discover" aria-hidden="true"></i>
      <i class="fa el-icon-place" aria-hidden="true"></i>
      <i class="fa el-icon-location" aria-hidden="true"></i>
      <i class="fa el-icon-location-outline" aria-hidden="true"></i>
      <i class="fa el-icon-location-information" aria-hidden="true"></i>
      <i class="fa el-icon-add-location" aria-hidden="true"></i>
      <i class="fa el-icon-delete-location" aria-hidden="true"></i>
      <i class="fa el-icon-map-location" aria-hidden="true"></i>
      <i class="fa el-icon-alarm-clock" aria-hidden="true"></i>
      <i class="fa el-icon-timer" aria-hidden="true"></i>
      <i class="fa el-icon-watch-1" aria-hidden="true"></i>
      <i class="fa el-icon-watch" aria-hidden="true"></i>
      <i class="fa el-icon-lock" aria-hidden="true"></i>
      <i class="fa el-icon-unlock" aria-hidden="true"></i>
      <i class="fa el-icon-key" aria-hidden="true"></i>
      <i class="fa el-icon-service" aria-hidden="true"></i>
      <i class="fa el-icon-mobile-phone" aria-hidden="true"></i>
      <i class="fa el-icon-bicycle" aria-hidden="true"></i>
      <i class="fa el-icon-truck" aria-hidden="true"></i>
      <i class="fa el-icon-ship" aria-hidden="true"></i>
      <i class="fa el-icon-basketball" aria-hidden="true"></i>
      <i class="fa el-icon-football" aria-hidden="true"></i>
      <i class="fa el-icon-soccer" aria-hidden="true"></i>
      <i class="fa el-icon-baseball" aria-hidden="true"></i>
      <i class="fa el-icon-wind-power" aria-hidden="true"></i>
      <i class="fa el-icon-light-rain" aria-hidden="true"></i>
      <i class="fa el-icon-lightning" aria-hidden="true"></i>
      <i class="fa el-icon-heavy-rain" aria-hidden="true"></i>
      <i class="fa el-icon-sunrise" aria-hidden="true"></i>
      <i class="fa el-icon-sunrise-1" aria-hidden="true"></i>
      <i class="fa el-icon-sunset" aria-hidden="true"></i>
      <i class="fa el-icon-sunny" aria-hidden="true"></i>
      <i class="fa el-icon-cloudy" aria-hidden="true"></i>
      <i class="fa el-icon-partly-cloudy" aria-hidden="true"></i>
      <i class="fa el-icon-cloudy-and-sunny" aria-hidden="true"></i>
      <i class="fa el-icon-moon" aria-hidden="true"></i>
      <i class="fa el-icon-moon-night" aria-hidden="true"></i>
      <i class="fa el-icon-dish" aria-hidden="true"></i>
      <i class="fa el-icon-dish-1" aria-hidden="true"></i>
      <i class="fa el-icon-food" aria-hidden="true"></i>
      <i class="fa el-icon-chicken" aria-hidden="true"></i>
      <i class="fa el-icon-fork-spoon" aria-hidden="true"></i>
      <i class="fa el-icon-knife-fork" aria-hidden="true"></i>
      <i class="fa el-icon-burger" aria-hidden="true"></i>
      <i class="fa el-icon-tableware" aria-hidden="true"></i>
      <i class="fa el-icon-sugar" aria-hidden="true"></i>
      <i class="fa el-icon-dessert" aria-hidden="true"></i>
      <i class="fa el-icon-ice-cream" aria-hidden="true"></i>
      <i class="fa el-icon-hot-water" aria-hidden="true"></i>
      <i class="fa el-icon-water-cup" aria-hidden="true"></i>
      <i class="fa el-icon-coffee-cup" aria-hidden="true"></i>
      <i class="fa el-icon-cold-drink" aria-hidden="true"></i>
      <i class="fa el-icon-goblet" aria-hidden="true"></i>
      <i class="fa el-icon-goblet-full" aria-hidden="true"></i>
      <i class="fa el-icon-goblet-square" aria-hidden="true"></i>
      <i class="fa el-icon-goblet-square-full" aria-hidden="true"></i>
      <i class="fa el-icon-refrigerator" aria-hidden="true"></i>
      <i class="fa el-icon-grape" aria-hidden="true"></i>
      <i class="fa el-icon-watermelon" aria-hidden="true"></i>
      <i class="fa el-icon-cherry" aria-hidden="true"></i>
      <i class="fa el-icon-apple" aria-hidden="true"></i>
      <i class="fa el-icon-pear" aria-hidden="true"></i>
      <i class="fa el-icon-orange" aria-hidden="true"></i>
      <i class="fa el-icon-coffee" aria-hidden="true"></i>
      <i class="fa el-icon-ice-tea" aria-hidden="true"></i>
      <i class="fa el-icon-ice-drink" aria-hidden="true"></i>
      <i class="fa el-icon-milk-tea" aria-hidden="true"></i>
      <i class="fa el-icon-potato-strips" aria-hidden="true"></i>
      <i class="fa el-icon-lollipop" aria-hidden="true"></i>
      <i class="fa el-icon-ice-cream-square" aria-hidden="true"></i>
      <i class="fa el-icon-ice-cream-round" aria-hidden="true"></i>
      <i class="" aria-hidden="true" style="cursor: pointer">空图标</i>

    </div>

  </el-dialog>
</template>

<script>
  //import "@/assets/css/font-awesome.min.css";
  export default {
    data() {
      return {
        dialogFormVisible: true
      }
    },
    methods: {
      selectIcon(e){
        var cn = e.target.className;
        if("ico-list"!=cn){
          this.$emit("handleSelectIcon",cn);
          this.dialogFormVisible = false;
        }
      },
      int() {
        this.dialogFormVisible=true;
      }
    }
  };
</script>

<style scoped>
  .fa{
    margin: 5px;
    padding: 5px;
    cursor:pointer;
    font-size: 18px;
    width: 21px;
    border-radius: 3px;
  }
  .fa:hover {
    background-color: #1d9d74;
    color: #ffffff;
  }
  .ico-list{
    height: 60vh;
    overflow: auto;
  }
</style>
